const contextFromAppModelOrContext = appModelOrFluxContext =>
    typeof appModelOrFluxContext === "string"
        ? appModelOrFluxContext
        : appModelOrFluxContext.get("fluxContext");

export default contextFromAppModelOrContext;



// WEBPACK FOOTER //
// ./app/controllers/util/contextFromAppModelOrContext.js